import { useEffect, useRef, useState, Fragment } from 'react';
import { config } from './config';
import { Menu, message, Modal, Tooltip } from 'antd';

import AddOrEditForm from './addOrEdit';
import Material from './materialSet';
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import { getBranchComponyList } from '@/services/homeService';
import { getActivityList, deleteActivity, activityType, getProductList } from '@/services/product'
import { getBizOpTypeEnum } from '@/services/customerServices';
import moment from 'moment';
import { queryAllDecoCompany } from '@/services/getUsers';

export default function ActivityManage () {
  const listRef = useRef<any>();
  const { confirm } = Modal;
  const [visible, setVisible] = useState(false);
  const [visibleOzt, setVisibleOzt] = useState(false);
  const [visibleMasterial, setVisibleMasterial] = useState(false);
  const [id, setId] = useState(0);
  const [editData, setEditData] = useState({});
  const [bizType, setBizType] = useState([]);
  const [companyCode, setCompanyCode] = useState([]);
  const [activityTypeList, setActivityTypeList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize } = values;
        console.log(values.query);
        const where = {};
        where['shopId'] = values.query.shopId;
        where['bizOpType'] = values.query.bizOpType;
        where['nameKeyword'] = values.query.nameKeyword;
        where['keyname'] = values.query.keyname;
        where['keyword'] = values.query.keyword;
        //console.log(where);
        getList(where, [current, pageSize], function (records, total) {
          resolve({ records, total });
        });
      } catch (e) {
        console.log(e);
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve) => {
      Promise.all([
        queryAllDecoCompany(),
        getBizOpTypeEnum(),
        activityType(),
        getProductList({
          prodTypes: ['PRODUCT_PACKAGE'],
          enabled: true,
        }),
      ]).then((res: any) => {
        const tagList = res[1]?.map(item => ({ value: item.key, label: item.description })) || [];
        setBizType(tagList);
        setCompanyCode(res[0]);
        setActivityTypeList(res[2]?.map(item => ({ value: item.key, label: item.description })) || []);
        const list = res[3]?.map(item => ({ label: item.prodName, value: item.id}));
        setProductList(list);
        resolve({
          companyOptions: res[0],
          bizTypeOptions: tagList,
        });
      });
    });
  };

  const getList = async (data = {}, pages = [1, 10], backFn = (a, b) => ({})) => {
    const res: any = await getActivityList({
      data: {
        ...data,
        queryProduct: true,
        queryShop: true,
      },
      params: {
        pageId: pages[0],
        pageSize: pages[1]
      }
    })
    const records = res?.list || [];
    const all = res?.count || 0;
    backFn(records, all);
  };

  const onAdd = () => {
    setId(0);
    setVisible(true);
    setEditData({});
  };

  const onDelete = async (id = '') => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteActivity(id);
          if (res.errorCode === 0) {
            message.success(res.message || '删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  };

  const materialBox = (record: any) => {
    setId(record.id);
    setCompanyList(record.shops);
    setVisibleMasterial(true);
  };
  const editAndAddBox = (record: any) => {
    setId(record.id);
    setVisible(true);

    setEditData({
      ...record,
      startDate: moment(record.startDate),
      endDate: moment(record.endDate),
    });

  };

  const columns = [
    {
      title: '活动ID',
      dataIndex: 'id',
      width: 150,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '活动名称',
      dataIndex: 'name',
      width: 150,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '活动描述',
      width: 200,
      dataIndex: 'description',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      itemType: 'dateTime'
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      itemType: 'dateTime'
    },
    {
      title: '类型',
      dataIndex: 'typeName',
      width: 150,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '适用门店',
      dataIndex: 'shops',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <span> { value?.map(item => item.companyName).join(',') } </span>
      )
    },
    {
      title: '适用产品',
      dataIndex: 'products',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <span> { value?.map(item => item.prodName).join(',') } </span>
      )
    },
    {
      title: '操作',
      width: 230,
      fixed: 'right',
      render: 'editCell',
    },
  ];

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    customRender: {
      editCell(text: any, record: any) {
        return (
          <Fragment>
            <STableActions>
              <SActionBtn onClick={() => editAndAddBox(record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDelete(record.id)}>删除</SActionBtn>
              <SActionBtn key="designServiceDraftFlow" onClick={() => materialBox(record)}>
                活动产品设置
              </SActionBtn>
            </STableActions>
          </Fragment>
        );
      },
      renderTooltip(text: any) {
        return (
          <Tooltip placement="topLeft" title={text}>
            {text}
          </Tooltip>
        );
      },
    },
  };

  return (
    <>
      <SLowcodeList config={{ ...config, columns }} searchMode="group" ref={listRef} {...extension} />
      {visible ? <AddOrEditForm
        editData={editData}
        setVisible={(status) => { setVisible(status); listRef?.current?.reload(); }}
        onClose = {() => setVisible(false)}
        activityTypeList={activityTypeList}
        productList={productList}
        companyList={companyCode}
        bizType={bizType}
        show={visible}
        id={id}
        listRef={listRef}
      /> : null}
      {visibleMasterial ? <Material id={id} companyList={companyList} show={visibleMasterial} setVisible={setVisibleMasterial} /> : null}
    </>
  );
}
